import { MetricWithNamedType } from './MachineMetricsComponent';
import { MetricParameterType } from './components/AddMetricModal/components/MetricParameterEditComponent';

export type ViewType = 'tvKpi' | 'desktopNonKpi';
export type MetricCatalogueType = {
  [metricName: string]: {
    machines: string[];
    viewType: ViewType;
    parameters?: MetricParameterType[];
  };
};

/**
 * @deprecated
 * Use machineUtils/getMachineMetricsCatalog instead, which has better type safety
 */
export function getMetricsByMachineAndViewType(
  machineId,
  viewType: ViewType,
  machineMetricCatalog: MetricCatalogueType
): MetricWithNamedType[] {
  const data = Object.keys(machineMetricCatalog).reduce(
    (acc, metricName, index) => {
      if (
        machineMetricCatalog[metricName].machines
          .map((x) => x.toString())
          .includes(machineId.toString()) &&
        machineMetricCatalog[metricName].viewType.includes(viewType)
      ) {
        acc.push({
          name: metricName,
          metric: metricName,
          order: index,
          enabled: false,
          parameters: machineMetricCatalog[metricName].parameters
        } as MetricWithNamedType);
      }
      return acc;
    },
    [] as MetricWithNamedType[]
  );
  return data;
}

export function filterMetricsByViewType(catalog, availableMetricsPerView) {
  const result = {};

  for (const viewType in availableMetricsPerView) {
    const availableMetrics = availableMetricsPerView[viewType];

    result[viewType] = catalog[viewType].filter((metric) =>
      availableMetrics.includes(metric.metric)
    );
  }

  return result;
}
